export function zipcode(input) {
  const validated = Promise.any([
    viacep(input),
    opencep(input),
  ]);

  return validated;
}

function viacep(cep) {
  cep = cep.replace(/\D/g, "");

  return fetch(`https://viacep.com.br/ws/${cep}/json/`).then(async (res) => {
    const data = await res.json();
    if ("erro" in data && data.erro) {
      throw new Error("Invalid zipcode from ViaCEP");
    }
    return data;
  });
}

function opencep(cep) {
  cep = cep.replace(/\D/g, "");

  return fetch(`https://opencep.com/v1/${cep}`).then(async (res) => {
    const data = await res.json();
    if (!data?.cep) {
      throw new Error("Invalid zipcode from OpenCEP");
    }
    return data;
  });
}
